import { BULK_MEDIUM_SCOPES } from 'features/ManageCampaigns/utils/inviteBulkMediumHelpers'

export const INVITE_EMAIL_DESIGN_SCOPE_ROWS = [
  {
    scope: BULK_MEDIUM_SCOPES.all,
    title: 'All campaigns',
    description: 'Every eligible invite campaign at this property.'
  },
  {
    scope: BULK_MEDIUM_SCOPES.ota,
    title: 'OTA campaigns',
    description: 'Guests who booked through an OTA channel.'
  },
  {
    scope: BULK_MEDIUM_SCOPES.direct,
    title: 'Direct campaigns',
    description: 'Guests who booked directly with the property.'
  }
]
